"use strict";
// (C) 2021-2022 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.Insight = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
/**
 * @internal
 */
exports.Insight = function (_a) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? 16 : _b, _c = _a.height, height = _c === void 0 ? 16 : _c;
    return (react_1.default.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 24 25", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
        react_1.default.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd" },
            react_1.default.createElement("g", { transform: "translate(-13.000000, -10.000000)", fill: "#94A1AD" },
                react_1.default.createElement("g", { transform: "translate(13.000000, 10.500000)" },
                    react_1.default.createElement("path", { d: "M15,5 L15,24 L9,24 L9,5 L15,5 Z M24,0 L24,24 L18,24 L18,0 L24,0 Z M6,12 L6,24 L0,24 L0,12 L6,12 Z M13.6,6.4 L10.4,6.4 L10.4,22.6 L13.6,22.6 L13.6,6.4 Z M22.6,1.4 L19.4,1.4 L19.4,22.6 L22.6,22.6 L22.6,1.4 Z M4.6,13.4 L1.4,13.4 L1.4,22.6 L4.6,22.6 L4.6,13.4 Z" }))))));
};
//# sourceMappingURL=Insight.js.map